import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-image",
  "use": "icon-image-usage",
  "viewBox": "0 0 72 96",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 72 96\" id=\"icon-image\">\n    <style>#icon-image .st0{fill:#fff}</style>\n    <path d=\"M0 2v92c0 1.1.9 2 2 2h68c1.1 0 2-.9 2-2V28H50c-1.1 0-2-.9-2-2V0H2C.9 0 0 .9 0 2z\" />\n    <path d=\"M71.9 24c-.1-.4-.2-.7-.4-1L52 1.2V24h19.9z\" />\n    <path class=\"st0\" d=\"M9.8 74V37h52.8v35.4l-14.9-20c-.1-.1-.2-.2-.3-.2s-.3.1-.3.2L34.4 67.9l-9.8-8.7c-.2-.1-.4-.1-.6 0L9.8 74z\" />\n    <path d=\"M30.4 46.9c0-2.8-2.3-5.1-5.1-5.1s-5.1 2.3-5.1 5.1 2.3 5.1 5.1 5.1c2.8-.1 5.1-2.3 5.1-5.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol